import React, { useState, useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { fetchUserById, updateUser } from "../../services/users";
import {
  ButtonRow,
  CancelButton,
  ConfirmButton,
  Input,
  InputWrapper,
  Label,
  ModalContent,
} from "../EditDriver/style";
import { ModalOverlay, ModalTitle } from "../../pages/Requests/style";
import Spinner from "../Spinner";

const EditUserModal = ({ userId, onClose }) => {
  const queryClient = useQueryClient();

  const { data: userData, isLoading } = useQuery({
    queryKey: ["user", userId],
    queryFn: () => fetchUserById(userId),
  });

  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
  });

  useEffect(() => {
    if (userData) {
      setFormData({
        name: userData.name || "",
        phone_number: userData.phone_number || "",
        email: userData.email || "",
      });
    }
  }, [userData]);

  const mutation = useMutation({
    mutationFn: (updatedData) =>
      updateUser({
        id: userId,
        data: {
          ...updatedData,
          phone_number: Number(updatedData.phone_number.trim()),
        },
      }),
    onSuccess: () => {
      toast.success("✅ تم تحديث بيانات المستخدم");
      queryClient.invalidateQueries({ queryKey: ["users", "all"] });
      queryClient.invalidateQueries({ queryKey: ["user", userId] });
      onClose();
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "فشل تحديث البيانات");
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const phone = String(formData.phone_number).trim();

    if (!formData.name || !phone || !formData.email) {
      toast.error("⚠️ جميع الحقول مطلوبة");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("⚠️ البريد الإلكتروني غير صالح");
      return;
    }

    if (!/^\d+$/.test(phone)) {
      toast.error("⚠️ رقم الهاتف يجب أن يحتوي على أرقام فقط");
      return;
    }

    mutation.mutate({ ...formData, phone_number: phone });
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalTitle>تعديل بيانات المستخدم</ModalTitle>

        {isLoading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "3rem" }}>
            <Spinner />
          </div>
        ) : (
          <>
            <InputWrapper>
              <Label>الاسم</Label>
              <Input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="ادخل الاسم"
              />
            </InputWrapper>

            <InputWrapper>
              <Label>رقم الهاتف</Label>
              <Input
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                placeholder="ادخل رقم الهاتف"
                dir="rtl"
              />
            </InputWrapper>

            <InputWrapper>
              <Label>البريد الإلكتروني</Label>
              <Input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="ادخل البريد الإلكتروني"
              />
            </InputWrapper>

            <ButtonRow>
              <CancelButton onClick={onClose}>إلغاء</CancelButton>
              <ConfirmButton onClick={handleSubmit} disabled={mutation.isLoading}>
                {mutation.isLoading ? "جاري الحفظ..." : "حفظ"}
              </ConfirmButton>
            </ButtonRow>
          </>
        )}
      </ModalContent>
    </ModalOverlay>
  );
};

export default EditUserModal;